module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入订单号查询"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("只显示两年内的信息")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "target": "_blank",
            "href": '//jazpan.com/view/' + (row.infoMap.fid || row.Fid)
          }
        }, [_vm._v(_vm._s(row.infoMap.fname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "amountxs"
        }, [_vm._v(_vm._s(row.infoMap.flamts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单ID",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "订单号",
            "width": "200",
            "trigger": "hover",
            "content": '[' + row.Mxid + ']: ' + row.Mchid
          }
        }, [_c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(row.Mxid))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载人",
      "width": "135",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Ips))]), _vm._v(" "), (row.Uid != '') ? _c('p', [_c('a', {
          attrs: {
            "target": "_blank",
            "href": '//jazpan.com/user/' + row.Uid
          }
        }, [_vm._v("\n              " + _vm._s(row.infoMap.nick) + "\n            ")])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Stat == -1) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("禁止下载")]) : (row.Stat == 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("未下载")]) : (row.Stat == 1) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("下载中")]) : (row.Stat == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已下载")]) : _c('el-tag', [_vm._v(_vm._s(row.Stat))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v("\n            " + _vm._s(_vm.getFlSize(row.Sizeln)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载时间",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group')]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  }), _vm._v(" "), _c('txTaxTips', {
    ref: "txTaxTips"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db86b99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/OrderList.vue
// module id = 1159
// module chunks = 1